const removeTrailingSlash = (url: string): string => url.replace(/\/$/, "");

export const ensureTrailingSlash = (url: string): string =>
  `${removeTrailingSlash(url)}/`;
